module.exports = __webpack_public_path__ + "static/media/9DESA19.19bcb6c2.jpg";